<template>
  <div ref="bgSetWrap">
    <div :class="customClass">
      <div class="bg-scan" :class="isThemeColorVal ? 'disable' : ''" @click="handleCommand('edit')">
        <span v-if="isThemeColorVal" class="theme-color color-scan linearGradient-span el-color-picker__color is-alpha">
          <span :style="getThemeColor"></span>
        </span>
        <span v-else class="color-scan linearGradient-span el-color-picker__color is-alpha">
          <span :style="getColor"></span>
        </span>
        <span v-if="isThemeColorVal" class="floatLeft color-text mr6">主题色</span>
        <span v-else class="color-text">{{ colorText }}</span>
        <el-tooltip
          class="item"
          effect="dark"
          :open-delay="1000"
          :content="isThemeColorVal ? '解除绑定' : '绑定主题色'"
          placement="top"
        >
          <span
            @click.stop="changeColorType"
            class="input-icon bind-icon right-handle-icon"
            :class="isThemeColorVal ? 'icon-portal-unbind' : 'icon-portal-binding'"
          ></span>
        </el-tooltip>
      </div>
      <single-input
        class="_percent60"
        :value.sync="colorOpacity"
        @update:value="handleColorOpacity"
        inputSuffixs="%"
        placeholder="请输入"
        :min="1"
        :max="100"
        :step="1"
      />
    </div>
    <div class="bg-set-dialog-wrap padding12" @click.stop="closebgSetStatu" v-if="showBgSetDialog">
      <div class="bg-set-dialog" @click.stop>
        <cx-base-color
          :showSecondTab.sync="showSecondTab"
          :showThirdTab.sync="showThirdTab"
          :activeName.sync="activeNameVal"
          :colorArr.sync="colorArrVal"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { simpleDeepClone, isEqual, isPlainObject } from "utils"
import { historyIgnoreWrap } from "utils/revork"
import { _colorChange } from "./colorPicker/component/mixin/color"
export default {
  name: "cxColorPicker",
  props: {
    colorArr: {
      type: null,
      required: false
    },
    color: {
      type: null,
      required: false
    },
    imgType: {
      type: [Number, String],
      required: false,
      default: 10
    },
    activeName: {
      type: String,
      default: "first"
    },
    isThemeColor: {
      type: Boolean,
      required: false,
      default: false
    },
    showSecondTab: {
      type: Boolean,
      default: false
    },
    showThirdTab: {
      type: Boolean,
      default: false
    },
    customClass: {
      type: String,
      default: "common-color-picker-warp"
    }
  },
  data() {
    return {
      showBgSetDialog: false,
      showBgSetArr: {
        showImgSet: false,
        showLinearGradientSet: false,
        showRadialGradientSet: false
      },
      defaultImg: {
        type: "img",
        label: "图片",
        imgUrl: "",
        clipSize: "cover",
        repeatType: "no-repeat",
        alignType: "center center",
        opacity: 100
      },
      defaultLinearGradient: {
        type: "linearGradient",
        label: "线性渐变",
        data: {
          angle: 20,
          stops: [
            ["rgba(255,255,255,0.5)", 0],
            ["rgba(255,255,255,1)", 1]
          ]
        }
      },
      defaultRadialGradient: {
        type: "radialGradient",
        label: "径向渐变",
        data: {
          siteX: 50,
          siteY: 50,
          stops: [
            ["rgba(255,255,255,0.5)", 0],
            ["rgba(255,255,255,1)", 1]
          ]
        }
      },
      colorText: "",
      colorOpacity: 100,
      gradientType: "纯色"
    }
  },
  computed: {
    themeColor() {
      return this.$store.state[this.request_prefix].page.themeColor || "#3D82F2"
    },
    getThemeColor() {
      return "background-color:" + this.themeColor
    },
    isThemeColorVal: {
      get() {
        return this.colorArrVal?.isThemeColor
      },
      set(val) {
        // 
        // this.colorArrVal && (this.$set(this.colorArrVal, 'isThemeColor', val))
        this.$emit("update:isThemeColor", val)
        // this.$emit("change", { type: "isThemeColor", value: val })]
        this.$emit("update:colorArr", {
          ...simpleDeepClone(this.colorArrVal),
          isThemeColor: val
        })
      }
    },
    colorArrVal: {
      get() {
        // 先对比当前数据格式是否是标准的默认格式
        if (!this.colorArr?.hasOwnProperty("themeColorId")) {
          return this.handleColorDataDefault()
        }
        if (!this.colorArr) {
          let bg = []
          return bg
        } else {
          if (typeof this.colorArr == "object") {
            if (this.colorArr.hasOwnProperty('themeColorId')) {
              // 说明是已经处理后的新颜色数据, 不用再处理
              this.colorOpacity = this.colorArr.colorOpacity
            } else {
              this.$set(this.colorArr, 'isThemeColor', this.isThemeColor ?? false)
              this.$set(this.colorArr, 'colorOpacity', 100)
              this.$set(this.colorArr, 'themeColorId', '')
            }
            this.colorBefore = simpleDeepClone(this.colorArr)
            return this.colorArr
          } else {
            // 把之前的颜色转化成对象
            let newVal = {
              color: this.colorArr,
              data: {
                angle: 0,
                stops: [
                  [this.colorArr, 0, {
                    isThemeColor: false,
                    colorOpacity: 100,
                    themeColorId: ''
                  }],
                  [this.colorArr, 1, {
                    isThemeColor: false,
                    colorOpacity: 100,
                    themeColorId: ''
                  }]
                ]
              },
              isThemeColor: this.isThemeColor,
              colorOpacity: 100,
              themeColorId: ''
            }
            this.colorBefore = simpleDeepClone(this.colorArr)
            historyIgnoreWrap(() => {
              this.$emit("update:colorArr", newVal)
            })()
            return newVal
          }
        }
      },
      set(val) {
        const newVal = simpleDeepClone(val)
        this.handleColorData(val)
        if (!isEqual(this.colorArr.data, val)) {
          // 透明度只保留一位小数
          newVal.color = this.getaFormatColor(newVal.color)
          newVal.data?.stops?.forEach(item => {
            if (item[0] && item[0].includes("rgba")) {
              item[0] = this.getaFormatColor(item[0])
            }
          })
          // newVal.opacity = Math.floor(Math.random() * 100)
          this.$emit("update:colorArr", newVal)
        }
      }
    },
    activeNameVal: {
      get() {
        return this.activeName
      },
      set(val) {
        this.$emit("update:activeName", val)
      }
    },
    getColor() {
      let tmpObj = this.colorArrVal
      let tmp = []
      let bgColor = ""
      if (tmpObj.data && tmpObj.data.stops) {
        tmpObj.data.stops.forEach(item => {
          tmp.push(item[0] + " " + item[1] * 100 + "%")
        })
        if (this.activeNameVal == "first") {
          if (!this.isThemeColorVal) {
            const colors = _colorChange(tmpObj.data.stops[0][0])
            let hex = colors.hex
            this.colorText = hex.replace('#', '')
            this.colorOpacity = (colors.a * 100).toFixed(0)
          }
          bgColor = "background-color:" + tmpObj.data.stops[0][0]
        } else if (this.activeNameVal == "second") {
          this.colorText = "线性渐变"
          bgColor = "background-image:linear-gradient(" + tmpObj.data.angle + "deg," + tmp.join(",") + ")"
        } else if (this.activeNameVal == "third") {
          this.colorText = "径向渐变"
          const siteX = tmpObj.data.siteX ? tmpObj.data.siteX : 0
          const siteY = tmpObj.data.siteY ? tmpObj.data.siteY : 0
          bgColor =
            "background-image:radial-gradient(at " +
            siteX +
            "% " +
            siteY +
            "%," +
            tmp.join(",") +
            ")"
        }
      } else if (tmpObj && !tmpObj.data) {
        if (tmpObj.color) {
          bgColor = "background-color:" + tmpObj.color
          this.colorText = tmpObj.color
        } else {
          bgColor = "background-color: rgba(255,255,255,0)"
          this.colorText = "rgba(255,255,255,0)"
        }
      }
      return bgColor
    },
    // colorOpacity: {
    //   get() {
    //     return this.colorArr.colorOpacity
    //   },
    //   set(val) {
    //     this.$emit("update:colorArr", {
    //       ...this.colorArr,
    //       colorOpacity: val
    //     })
    //   }
    // },
  },
  mounted() {
    document.getElementById("app").addEventListener("click", this.hidder, true)
  },
  beforeDestroy() {
    document.getElementById("app").removeEventListener("click", this.hidder, true)
  },
  methods: {
    hexToRgba(hex) {
      if (hex && hex.indexOf("#") > -1) {
        const colorObj = this.parseColorString(hex)
        return this.toRgbaString(colorObj)
      } else {
        return hex
      }
    },
    toRgbaString(colorObj, num) {
      let n = num || 10000
      const { r, g, b, a = 1 } = colorObj
      return `rgba(${r},${g},${b},${Math.floor(a * n) / n})`
    },
    parseColorString(color) {
      let hex = color.slice(1)
      let a = 1
      if (hex.length === 3) {
        hex = `${hex[0]}${hex[0]}${hex[1]}${hex[1]}${hex[2]}${hex[2]}`
      }
      if (hex.length === 8) {
        a = parseInt(hex.slice(6), 16) / 255
        hex = hex.slice(0, 6)
      }
      const bigint = parseInt(hex, 16)
      return {
        r: (bigint >> 16) & 255,
        g: (bigint >> 8) & 255,
        b: bigint & 255,
        a
      }
    },
    hidder(e) {
      let ele = this.$refs.bgSetWrap
      if (ele && ele.contains(e.target)) {
        return
      } else {
        this.showBgSetDialog = false
      }
    },
    handleCommand(type) {
      // if (this.isThemeColorVal) return
      this.showBgSetDialog = true
      let defaultData = "default"
      if (type !== "edit" && this[defaultData]) {
        this.colorArr.unshift(JSON.parse(JSON.stringify(this[defaultData])))
      }
    },
    closebgSetStatu() {
      this.showBgSetDialog = undefined
    },
    changeColorType() {
      this.isThemeColorVal = !this.isThemeColorVal
    },
    handleColorData(val) {
      let colorArr = val
      if (this.activeNameVal == "first") {
        colorArr.type = "color"
        colorArr.label = "颜色"
      } else if (this.activeNameVal == "second") {
        colorArr.type = "linearGradient"
        colorArr.label = "线性渐变"
      } else if (this.activeNameVal == "third") {
        colorArr.type = "radialGradient"
        colorArr.label = "径向渐变"
      }
      if (colorArr.data?.stops) {
        colorArr.data.stops[0][0] = this.hexToRgba(colorArr.data.stops[0][0])
        if (colorArr.data.stops[1]) {
          colorArr.data.stops[1][0] = this.hexToRgba(colorArr.data.stops[1][0])
        }
        colorArr.color = colorArr.data.stops[0][0]
      }
    },
    // 格式化颜色值rgba，把透明度置为一位小数
    getaFormatColor(color) {
      const regArr = /rgba\((\d*),\s*(\d*),\s*(\d*),\s*(.*)\)/.exec(color)
      if (!regArr) {
        return color
      }
      return `rgba(${regArr[1]},${regArr[2]},${regArr[3]},${
        regArr[4].includes(".") ? regArr[4].slice(0, 4) : regArr[4]
      })`
    },
    // 默认数据处理，将之前的颜色对象统一改成当前结构
    handleColorDataDefault() {
      const defaultColor = {
        type: "color",
        label: "颜色",
        color: "",
        colorOpacity: 100,
        isThemeColor: this.isThemeColor,
        themeColorId: 0,
      }
      let newVal = isPlainObject(this.colorArr) ? simpleDeepClone({
        ...this.colorArr
      }) : {color: this.colorArr || "#ffffff", type: 'color', label: '颜色'}
      // 对比this.colorArr和defaultColor，如果存在则替换，不存在则添加
      Object.keys(defaultColor).forEach((key) => {
        if (!newVal.hasOwnProperty(key)) {
          newVal[key] = defaultColor[key]
        }
      })
      newVal.isThemeColor = this.isThemeColor
      if (newVal.hasOwnProperty("data")) {
        if (newVal.data.hasOwnProperty("stops")) {
          if (Array.isArray(newVal.data.stops)) {
            newVal.data.stops.forEach((item, index) => {
              if (Array.isArray(item) && item.length === 2) {
                item.push({
                  colorOpacity: 100,
                  isThemeColor: false,
                  themeColorId: 0,
                })
              }
            })
          }
        }
      } else {
        newVal.data = {
          stops: [
            [
              newVal.color,
              0,
              {
                colorOpacity: 100,
                isThemeColor: false,
                themeColorId: 0,
              },
            ],
            [
              newVal.color,
              1,
              {
                colorOpacity: 100,
                isThemeColor: false,
                themeColorId: 0,
              },
            ]
          ],
        }
      }
      this.$emit("update:colorArr", newVal)
      return newVal
    },
    handleColorOpacity(val) {
      if (!this.isThemeColorVal) {
        // 根据hex和opacity值，计算出rgba值
        let color = this.getaFormatColor(this.hexToRgba("#" + this.colorText))
        const alpha = val / 100
        // 替换rgba的透明度
        color = color.replace(/rgba\((\d*),\s*(\d*),\s*(\d*),\s*(.*)\)/, (match, p1, p2, p3, p4) => {
          return `rgba(${p1},${p2},${p3},${alpha})`
        })
        if (this.colorArr?.data?.stops) {
          this.colorArr.data.stops[0][0] = color
        }
        this.$emit("update:colorArr", {
          ...this.colorArr,
          color
        })
      } else {
          this.$emit("update:colorArr", {
          ...this.colorArr,
          colorOpacity: val
        })
      }
    }
  }
}
</script>

<style scoped lang="scss">
.bg-color-set {
  border: none;
  background: var(--inputBg);
}

.padding12 {
  padding: 12px;
  box-sizing: border-box;
}

.bg-set-dialog-wrap {
  position: fixed;
  top: 0;
  right: 0;
  width: 260px;
  bottom: 0;
  background: var(--dialogShade);
  z-index: 9999;
}

.bg-set-dialog {
  position: absolute;
  top: 50%;
  right: 0;
  width: 260px;
  padding: 12px;
  transform: translateY(-50%);
  background: var(--leftMenuBgColor);
  border: 1px solid var(--borderColorFour);
  box-sizing: border-box;
  box-shadow: 0 6px 16px -8px rgba(0, 0, 0, 0.08), 0 9px 28px rgba(0, 0, 0, 0.05), 0 12px 48px 16px rgba(0, 0, 0, 0.03);
  border-radius: 4px;
}
.bg-scan {
  font-size: 14px;
  border-radius: 4px;
  height: 32px;
  padding: 0 6px;
  background-color: var(--inputBg);
  margin-right: 1px;
  display: flex;
  align-items: center;
  position: relative;
  &:hover {
    .right-handle-icon {
      display: inline-block;
    }
    .color-text {
      width: calc(100% - 50px);
    }
  }
}
.common-color-picker-warp {
  display: flex;
  align-items: center;
  .bg-scan {
    width: calc(100% - 60px);
  }
  .img-icon,
  .color-scan {
    display: inline-block;
    border-radius: 4px;
    width: 20px;
    height: 20px;
    vertical-align: middle;
    margin-right: 4px;
  }
  .color-scan > span {
    display: inline-block;
    width: 100%;
    height: 100%;
  }
  .color-scan.theme-color {
    border-radius: 50%;
  }
  .icon-portal-delete {
    font-size: 15px;
  }
  ._percent60 {
    width: 60px;
  }
}
.border-color-picker-warp {
  .img-icon,
  .color-scan {
    display: inline-block;
    border-radius: 4px;
    width: 20px;
    height: 20px;
    vertical-align: middle;
    margin-right: 4px;
  }
  .color-scan > span {
    display: inline-block;
    width: 100%;
    height: 100%;
  }
  .color-scan.theme-color {
    border-radius: 50%;
  }
  .icon-portal-delete {
    font-size: 15px;
  }
  ._percent60 {
    margin-top: 8px;
  }
}

.el-dropdown-link {
  display: inline-block;
  width: 24px;
  height: 24px;
  line-height: 24px;
  text-align: center;
  border-radius: 4px;
  color: var(--themeColor);

  &:hover {
    background-color: var(--iconHoverBgColor);
  }

  &.disabled {
    color: var(--themeColorDisabled);

    &:hover {
      background-color: transparent;
    }
  }
}
.color-text {
  // width: calc(100% - 50px);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
</style>
